module.exports = __webpack_public_path__ + "static/img/rank.2e0a7fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/comment/rank.png
// module id = 1196
// module chunks = 18